import iconPurple from './IconPurple.png';

const LOGO_ICON_SRC = iconPurple;

export default LOGO_ICON_SRC;
